import { render, staticRenderFns } from "./notFoundCom.vue?vue&type=template&id=2c672e48&"
import script from "./notFoundCom.vue?vue&type=script&lang=js&"
export * from "./notFoundCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports